import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/yardtutor/yardtutor.com/frontend/releases/20251215120152/components/blog/ArticleImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/yardtutor/yardtutor.com/frontend/releases/20251215120152/components/blog/ArticleOutline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/yardtutor/yardtutor.com/frontend/releases/20251215120152/components/blog/AuthorPaginationWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/yardtutor/yardtutor.com/frontend/releases/20251215120152/components/blog/CategoryPaginationWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/yardtutor/yardtutor.com/frontend/releases/20251215120152/components/core/ArticleSlider.tsx");
;
import(/* webpackMode: "eager" */ "/home/yardtutor/yardtutor.com/frontend/releases/20251215120152/components/core/ResponsiveImage.tsx");
;
import(/* webpackMode: "eager" */ "/home/yardtutor/yardtutor.com/frontend/shared/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/yardtutor/yardtutor.com/frontend/shared/node_modules/next/dist/client/link.js");
